import app from '@/app';
/* @ngInject */
const Resource = abstractResource => abstractResource('user');

app.factory('User', Resource);
